import { render, staticRenderFns } from "./articulos.vue?vue&type=template&id=2e26742c&scoped=true&"
import script from "./articulos.vue?vue&type=script&lang=ts&"
export * from "./articulos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e26742c",
  null
  
)

export default component.exports